import React from 'react';
import { toast } from 'sonner';

export const _showToast = (heading: string, description: string) => {
    toast.error(
        <div className='toast' role='alert'>
            <div className='toast-header'>
                <h4>{heading}</h4>
            </div>
            <div className='toast-body'>
                <span>{description}</span>
            </div>
        </div>
    );
};
